/**
 * Alaska: Editor
 * Public: Carousels
 * @version 1.0
 */

import {Splide} from "@splidejs/splide";
document.addEventListener("alpine:init", () => {

    // Init
    const init_carousels = (selector, options) => {
        const elements = document.querySelectorAll(selector);

        if (!elements.length) { return; }

        console.group("Carousels");
            elements.forEach((el) => {
                console.log(el)
                new Splide(el, options).mount();
            });
        console.groupEnd();
    };

    // Config
    const default_options = {
        autoplay: true,
        pagination: true,
        perMove: 1,
        perPage: 3,
        rewind: true,
        interval: 1000,
        breakpoints: {
            440: {
                perPage: 1,
            },
            640: {
                perPage: 2,
            },
        },
        classes: {
            pagination: 'splide__pagination default-pagination',
        }
    };

    init_carousels('.card-carousel', {
        type: 'loop',
        arrows: false,
        pagination: false,
        perMove: 1,
        perPage: 3,
        breakpoints: {
            440: {perPage: 1},
            640: {perPage: 2},
        }
    })

    // Utilities
    init_carousels(".default-carousel", {
        ...default_options,
        arrows: false,
    });

    init_carousels(".default-carousel-responsive", {
        ...default_options,
        type: "loop",
        arrows: false,
        pagination: false,
        perMove: 1,
        perPage: 7,
        breakpoints: {
            440: {perPage: 2},
            640: {perPage: 3},
            768: {perPage: 4},
            1024: {perPage: 5},
            1280: {perPage: 6}
        }
    });

});